import { useQuery } from '@tanstack/react-query';
import { useCustomFetch } from '../custom-fetch';

interface IAvailabilityResponse {
  fetching: boolean;
  data: Record<string, { 
    availableCount: number;
    availableCategories?: Record<string, number>;
  }>;
}

export const useStationAvailability = (station: string, yearMonth: string) => {
  const customFetch = useCustomFetch();

  return useQuery<IAvailabilityResponse, Error>({
    queryKey: ['stationAvailability', station, yearMonth],
    queryFn: async () => {
      const [data] = await customFetch<IAvailabilityResponse>(`/json/availability?station=${station}&yearMonth=${yearMonth}`);
      return data;
    },
    // For React Query v4/v5, refetchInterval accepts the query object
    refetchInterval: (query: any) => {
      const isFetching = query?.state?.data?.fetching;
      return isFetching ? 1000 : false;
    },
    enabled: !!station && !!yearMonth,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
